import request from '../request';

//获取划线类型
export default {
  //折线类型-使用
  getPointsType(data) {
    return request.get('/setting/getPointsType', data);
  },

  //折线类型-列表
  lists(data) {
    return request.get('/adminSetting/lists', data);
  },

  //折线类型-添加
  add(data) {
    return request.post('/AdminSetting/add', data);
  },

  //折线类型-修改
  edit(data) {
    return request.post('/AdminSetting/update', data);
  },

  //折线类型-删除
  delete(data) {
    return request.post('/adminSetting/delete', data);
  },
};
